import { Injectable } from '@angular/core';
import { ActivationData } from '@features/auth/types';
import { IActivationService } from './activation.service.interface';

@Injectable({
  providedIn: 'root',
})
export class ActivationService implements IActivationService {
  public getActivationData(): ActivationData | null {
    const data = localStorage.getItem('activationData');
    if (!data) {
      return null;
    }

    return JSON.parse(data);
  }

  public setActivationData(data: ActivationData) {
    localStorage.setItem('activationData', JSON.stringify(data));
  }

  public isActivatedSchoolDevice(): boolean {
    return !!this.getActivationData() && !this.getActivationData()?.isHomeDevice;
  }

  public isActivatedHomeDevice(): boolean {
    const activationData = this.getActivationData();
    return activationData?.isHomeDevice || false;
  }

  public setPlayerGroupCode(playerGroupCode: string) {
    localStorage.setItem('playerGroupCode', playerGroupCode);
  }

  public getPlayerGroupCode(): string | null {
    return localStorage.getItem('playerGroupCode') || null;
  }

  public deletePlayerGroupCode() {
    localStorage.removeItem('playerGroupCode');
  }

  public deleteActivationData() {
    localStorage.removeItem('activationData');
    this.deletePlayerGroupCode();
  }
}
